const STORAGE_PREFIX = 'eyeconx.invoiceSeen';

const getStorageKey = (clinicId) => `${STORAGE_PREFIX}.${clinicId}`;

const readState = (clinicId) => {
    if (!clinicId) {
        return { seenInvoiceIds: [] };
    }

    try {
        const raw = localStorage.getItem(getStorageKey(clinicId));
        if (!raw) {
            return { seenInvoiceIds: [] };
        }

        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed?.seenInvoiceIds)) {
            return { seenInvoiceIds: parsed.seenInvoiceIds };
        }

        return { seenInvoiceIds: [] };
    } catch {
        return { seenInvoiceIds: [] };
    }
};

const writeState = (clinicId, state) => {
    if (!clinicId) {
        return;
    }

    localStorage.setItem(
        getStorageKey(clinicId),
        JSON.stringify({
            seenInvoiceIds: Array.isArray(state.seenInvoiceIds) ? state.seenInvoiceIds : [],
        }),
    );
};

export const getSeenInvoiceIds = (clinicId) => new Set(readState(clinicId).seenInvoiceIds);

export const markInvoiceSeen = (clinicId, invoiceId) => {
    if (!clinicId || !invoiceId) {
        return;
    }

    const state = readState(clinicId);
    const seenInvoiceIds = new Set(state.seenInvoiceIds);
    seenInvoiceIds.add(invoiceId);
    writeState(clinicId, { seenInvoiceIds: [...seenInvoiceIds] });
};

export const markInvoicesSeen = (clinicId, invoiceIds = []) => {
    if (!clinicId || !invoiceIds.length) {
        return;
    }

    const state = readState(clinicId);
    const seenInvoiceIds = new Set(state.seenInvoiceIds);
    invoiceIds.filter(Boolean).forEach((invoiceId) => seenInvoiceIds.add(invoiceId));
    writeState(clinicId, { seenInvoiceIds: [...seenInvoiceIds] });
};
